const description = {
    email: 'ایمیل',
    phone_number: 'شماره تلفن',
    username: 'نام کاربری',
    reminder: 'یادآوری',
    not_found: '۴۰۴ یافت نشد',
    agree_with_terms: 'خوانده‌ام و با ',
    agree_with_terms_modal: 'برای ادامه، لطفاً با <link></link> موافقت کنید.',
    terms_of_use: 'شرایط استفاده',
    sign_in: 'ورود',
    privacy_policy: 'سیاست حریم خصوصی',
    create_account: 'ایجاد حساب',
    switch_account: 'تغییر حساب',
    or: 'یا',
    and: 'و',
    enter_passcode: 'کد تأیید به {{address}} {{target}} شما ارسال شد',
    passcode_sent: 'کد تأیید مجدداً ارسال شد',
    resend_after_seconds: 'هنوز دریافت نکرده‌اید؟ ارسال مجدد پس از <span>{{seconds}}</span> ثانیه',
    resend_passcode: 'هنوز دریافت نکرده‌اید؟ <a>ارسال مجدد کد تأیید</a>',
    create_account_id_exists: 'حسابی با {{value}} از قبل وجود دارد. ادامه برای ورود.',
    link_account_id_exists: 'حساب با {{type}} {{value}} از قبل وجود دارد. آیا می‌خواهید پیوند دهید؟',
    sign_in_id_does_not_exist: 'هیچ حسابی برای {{value}} یافت نشد. یک حساب جدید ایجاد کنید؟',
    sign_in_id_does_not_exist_alert: 'حساب با {{type}} {{value}} وجود ندارد.',
    create_account_id_exists_alert: 'حساب با {{type}} {{value}} به حساب دیگری مرتبط است. لطفاً {{type}} دیگری امتحان کنید.',
    social_identity_exist: '{{type}} {{value}} به حساب دیگری مرتبط است. لطفاً {{type}} دیگری امتحان کنید.',
    bind_account_title: 'پیوند یا ایجاد حساب',
    social_create_account: 'می‌توانید یک حساب جدید ایجاد کنید.',
    social_link_email: 'می‌توانید ایمیل دیگری پیوند دهید',
    social_link_phone: 'می‌توانید تلفن دیگری پیوند دهید',
    social_link_email_or_phone: 'می‌توانید ایمیل یا تلفن دیگری پیوند دهید',
    social_bind_with_existing: 'حساب مرتبطی یافتیم که قبلاً ثبت شده است و می‌توانید آن را مستقیماً پیوند دهید.',
    skip_social_linking: 'پیوند به حساب موجود را رد می‌کنید؟',
    reset_password: 'بازنشانی رمز عبور',
    reset_password_description: '{{types, list(type: disjunction;)}} مرتبط با حساب خود را وارد کنید تا کد تأیید برای بازنشانی رمز عبور ارسال شود.',
    reset_password_magic_link_description: 'برای ادامه بازنشانی گذرواژه، آدرس ایمیل مرتبط با حساب خود را وارد کنید.',
    new_password: 'رمز عبور جدید',
    set_password: 'تنظیم رمز عبور',
    password_changed: 'رمز عبور تغییر یافت',
    no_account: 'هنوز حساب ندارید؟ ',
    have_account: 'قبلاً حساب دارید؟',
    enter_password: 'رمز عبور را وارد کنید',
    enter_password_for: 'با رمز عبور وارد {{method}} {{value}} شوید',
    enter_username: 'نام کاربری را تنظیم کنید',
    enter_username_description: 'نام کاربری جایگزینی برای ورود است. نام کاربری باید فقط شامل حروف، اعداد و زیرخط باشد.',
    enter_username_policy_description: 'نام کاربری جایگزینی برای ورود است. {{requirements}}',
    link_email: 'پیوند ایمیل',
    link_phone: 'پیوند تلفن',
    link_email_or_phone: 'پیوند ایمیل یا تلفن',
    link_email_description: 'برای امنیت بیشتر، لطفاً ایمیل خود را با حساب پیوند دهید.',
    link_phone_description: 'برای امنیت بیشتر، لطفاً تلفن خود را با حساب پیوند دهید.',
    link_email_or_phone_description: 'برای امنیت بیشتر، لطفاً ایمیل یا تلفن خود را با حساب پیوند دهید.',
    continue_with_more_information: 'برای امنیت بیشتر، لطفاً اطلاعات حساب زیر را تکمیل کنید.',
    create_your_account: 'حساب خود را ایجاد کنید',
    sign_in_to_your_account: 'وارد حساب خود شوید',
    device_activation: 'فعال‌سازی دستگاه',
    device_activation_description: 'کدی که روی دستگاهتان نمایش داده می‌شود را وارد کنید. مطمئن شوید که مطابقت دارد، سپس برای ورود به این دستگاه ادامه دهید.',
    device_activation_error_description: 'کدی که روی دستگاهتان نمایش داده می‌شود را وارد کنید.',
    device_activation_success: 'دستگاه شما اکنون متصل شد!',
    device_activation_success_description: 'برای ادامه به دستگاه خود بازگردید.',
    no_region_code_found: 'کد منطقه‌ای یافت نشد',
    verify_email: 'ایمیل خود را تأیید کنید',
    verify_phone: 'شماره تلفن خود را تأیید کنید',
    password_requirements: 'رمز عبور {{items, list}}.',
    password_requirement: {
        length_one: 'حداقل {{count}} کاراکتر لازم است',
        length_two: 'حداقل {{count}} کاراکتر لازم است',
        length_few: 'حداقل {{count}} کاراکتر لازم است',
        length_many: 'حداقل {{count}} کاراکتر لازم است',
        length_other: 'حداقل {{count}} کاراکتر لازم است',
        character_types_one: 'باید حداقل {{count}} نوع از حروف بزرگ، حروف کوچک، اعداد و نمادها را داشته باشد',
        character_types_two: 'باید حداقل {{count}} نوع از حروف بزرگ، حروف کوچک، اعداد و نمادها را داشته باشد',
        character_types_few: 'باید حداقل {{count}} نوع از حروف بزرگ، حروف کوچک، اعداد و نمادها را داشته باشد',
        character_types_many: 'باید حداقل {{count}} نوع از حروف بزرگ، حروف کوچک، اعداد و نمادها را داشته باشد',
        character_types_other: 'باید حداقل {{count}} نوع از حروف بزرگ، حروف کوچک، اعداد و نمادها را داشته باشد',
    },
    username_requirements: 'نام کاربری {{items, list}}.',
    username_requirement: {
        length: 'باید بین {{min}} تا {{max}} کاراکتر باشد',
        characters: 'فقط می‌تواند شامل {{characters, list}} باشد',
    },
    username_character: {
        uppercase: 'حروف بزرگ',
        lowercase: 'حروف کوچک',
        number: 'اعداد',
        underscore: 'زیرخط',
    },
    use: 'استفاده',
    single_sign_on_email_form: 'آدرس ایمیل سازمانی خود را وارد کنید',
    single_sign_on_connectors_list: 'سازمان شما ورود یکپارچه (SSO) را برای حساب ایمیل {{email}} فعال کرده است. می‌توانید با ارائه‌دهندگان SSO زیر ادامه دهید.',
    single_sign_on_enabled: 'ورود یکپارچه برای این حساب فعال است',
    authorize_title: 'مجوز دادن به {{name}}',
    unregistered_client_notice: 'این برنامه توسط <hostname>{{host}}</hostname> خوداظهاری شده است، از جمله نام و لوگوی آن. لطفاً پیش از ادامه، نام میزبان را بررسی کنید.',
    request_permission: '{{name}} درخواست دسترسی به موارد زیر را دارد:',
    grant_organization_access: 'اعطای دسترسی به سازمان:',
    authorize_personal_data_usage: 'مجوز استفاده از اطلاعات شخصی شما:',
    authorize_organization_access: 'مجوز دسترسی به سازمان خاص:',
    user_scopes: 'اطلاعات شخصی کاربر',
    organization_scopes: 'دسترسی سازمان',
    authorize_agreement: `با مجوز دادن به دسترسی، با <link></link> {{name}} موافقت می‌کنید.`,
    authorize_agreement_with_redirect: `با مجوز دادن به دسترسی، با <link></link> {{name}} موافقت می‌کنید و به {{uri}} هدایت خواهید شد.`,
    not_you: 'شما نیستید؟',
    user_id: 'شناسه کاربری: {{id}}',
    redirect_to: 'به {{name}} هدایت خواهید شد.',
    auto_agreement: 'با ادامه، با <link></link> موافقت می‌کنید.',
    identifier_sign_in_description: '{{types, list(type: disjunction;)}} خود را برای ورود وارد کنید.',
    all_sign_in_options: 'همه گزینه‌های ورود',
    identifier_register_description: '{{types, list(type: disjunction;)}} خود را برای ایجاد حساب جدید وارد کنید.',
    all_account_creation_options: 'همه گزینه‌های ایجاد حساب',
    back_to_sign_in: 'بازگشت به ورود',
    password_expired: 'رمز عبور شما منقضی شده و باید قبل از ورود بازنشانی شود.',
    password_expiration_reset: 'بازنشانی رمز عبور',
    support_email: 'ایمیل پشتیبانی: <link></link>',
    support_website: 'وب‌سایت پشتیبانی: <link></link>',
    switch_account_title: 'در حال حاضر با {{account}} وارد شده‌اید',
    switch_account_description: 'برای ادامه، از حساب فعلی خارج می‌شوید و به‌طور خودکار به حساب جدید تغییر می‌کنید.',
    about_yourself: 'درباره خودتان بگویید',
    verify_identity: 'هویت خود را تأیید کنید',
    choose_verification_method: 'روش ورود خود را انتخاب کنید',
    verification_method: {
        passkey: 'کلید عبور',
        passkey_description: 'از طریق دستگاه یا سخت‌افزار USB خود تأیید کنید',
        password: 'رمز عبور',
        password_description: 'رمز عبور خود را وارد کنید',
        email_verification_code: 'کد تأیید ایمیل',
        phone_verification_code: 'کد تأیید تلفن',
        verification_code_description: 'ارسال به {{target}}',
    },
};
export default Object.freeze(description);
